import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { adminLogin } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock, Loader2 } from "lucide-react";
import { toast } from "sonner";

const AdminLoginPage = () => {
  const { t, setAdminToken } = useApp();
  const [form, setForm] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await adminLogin(form);
      setAdminToken(res.token);
      toast.success("Welcome, admin!");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-64px)] flex items-center justify-center px-4 py-10" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-white border border-[#E2E8F0] rounded-2xl p-8 shadow-sm">
        <div className="w-14 h-14 rounded-xl bg-[#1E293B] flex items-center justify-center mb-4">
          <Lock className="w-7 h-7 text-white" />
        </div>
        <h1 className="font-heading font-bold text-2xl text-[#1E293B]">{t("adminLogin")}</h1>
        <p className="text-sm text-slate-500 mt-1">Shop owner access</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label htmlFor="admin-user" className="text-sm">{t("username")}</Label>
            <Input
              id="admin-user"
              data-testid="admin-username"
              value={form.username}
              onChange={(e) => setForm({ ...form, username: e.target.value })}
              className="mt-1.5 h-12 bg-white"
              required
            />
          </div>
          <div>
            <Label htmlFor="admin-pass" className="text-sm">{t("password")}</Label>
            <Input
              id="admin-pass"
              data-testid="admin-password"
              type="password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="mt-1.5 h-12 bg-white"
              required
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            data-testid="admin-login-btn"
            className="w-full h-12 rounded-md bg-[#1E293B] hover:bg-[#0f172a] text-white font-semibold"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : t("loginBtn")}
          </Button>
          <div className="text-center mt-3">
            <Link to="/admin/forgot" data-testid="forgot-password-link" className="text-xs text-slate-500 hover:text-[#D97706] font-medium">
              Forgot password?
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminLoginPage;
